import { Stack, StackProps, Typography } from '@mui/material';
import { FC } from 'react';

interface Props extends Pick<StackProps, 'sx'> {
    title: string;
    text: string;
    imageUrl: string;
}

export const BenefitItem: FC<Props> = ({ title, text, imageUrl, sx }) => (
    <Stack direction="row" sx={sx} gap="8px" alignItems="flex-start">
        <img src={imageUrl} alt={title} style={{ width: '64px', flexShrink: 0 }} />
        <Stack gap="8px">
            <Typography variant="body1Medium" color="background.default">
                {title}
            </Typography>
            <Typography variant="captionLight" sx={{ fontSize: '16px', color: 'text.lightGray' }}>
                {text}
            </Typography>
        </Stack>
    </Stack>
);
